import {
  filterK8Grades,
  sortGradesWithKFirst,
  getRelevantCourseList,
} from 'experienceComponents/CreateInstanceShared/dataUtils'
import {
  convertGradeToDisplayValue,
  convertGradeNameToLabel,
  getProgramName,
  createViewClassBehavior,
} from './data'

// Filter and sort configuration
export const courseFilterConfig = {
  filterFunction: filterK8Grades,
  sortFunction: sortGradesWithKFirst,
  getRelevantCourseList: courses => getRelevantCourseList(courses, false), // false = classes
  convertGradeToDisplayValue: convertGradeToDisplayValue,
  isSmallGroup: false, // Explicit flag - don't rely on function name matching
}

// Program mapping configuration
export const courseProgramConfig = {
  convertGradeNameToLabel: convertGradeNameToLabel,
  getProgramName: getProgramName,
}

// View class behavior configuration
export const courseViewClassConfig = {
  createViewClassBehavior: createViewClassBehavior,
}
